module.exports = __webpack_public_path__ + "static/img/205_phase_function_Paper_PointsHejduk_Prediction.38f1f90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/205_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Ften
// module chunks = 0